import React from 'react';
import { Modal, List, Typography, Divider } from 'antd';

const { Text } = Typography;

const CreditUnionModal = ({ open, onClose, breakdown, total }) => {
  const items = Array.isArray(breakdown) ? breakdown : [];
  const computedTotal = typeof total === 'number' ? total : items.reduce((s, x) => s + (x.count || 0), 0);
  return (
    <Modal
      title="Active Members by Credit Union"
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12 }}>
        <Text strong style={{ fontSize: 16 }}>Total Active Members</Text>
        <Text strong style={{ fontSize: 20 }}>{computedTotal}</Text>
      </div>
      <Divider style={{ margin: '8px 0 12px' }} />
      <List
        itemLayout="horizontal"
        dataSource={items}
        renderItem={(item) => (
          <List.Item style={{ paddingLeft: 0, paddingRight: 0 }}>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', gap: 12 }}>
              <Text>{item.name}</Text>
              <Text strong>{item.count}</Text>
            </div>
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default CreditUnionModal;


